const { getObjectValue } = require('@root/helpers');

module.exports = {
	products: (state) => state.products,
	categories: (state) => state.categories,
	attributes: (state) => state.attributes,
	enabledAttributes: (state) => state.enabled_attributes,
	selectedProduct: (state) => state.selectedProduct,
};
